<div *ngIf="definition; else loading">
<admin-page-second [title]="'pages.reporting.title' | translate">

  <admin-section-standard [title]="('pages.reporting.title.case' | translate)">
    <admin-channel-view-desc [config]="definition.config"/>
    <admin-panel-result>
      <ng-template #header>
        <div class="row fs-4">
          <div class="" style="width: 13%">
            <div class="text-muted mb-1">Risk</div>
            <div class="text-uppercase">
              <span [ngClass]="'bg-' + riskClass(selected.risk!)" class="badge">{{('pages.lookup.single.result.alert_risk.' + selected.risk | translate)}}</span>
            </div>
          </div>

          <div class="border-start" style="width: 13%">
            <div class="text-muted mb-1">Status</div>
            <div class="text-uppercase">
              <span [ngClass]="'text-' + statusClass(selected.status!)" class="fw-bolder status-badge">{{ selected.status }}</span>
            </div>
          </div>

          <div class="border-start" style="width: 20%">
            <div class="text-muted mb-1">Case</div>
            <div class="text-uppercase">
              <span class="fw-semibold">{{ selected.internal }}</span>
            </div>
          </div>

          <div class="border-start" style="width: 20%">
            <div class="text-muted mb-1">Record</div>
            <div class="text-uppercase">
              <span class="fw-semibold">{{ selected.record! }}</span>
            </div>
          </div>

          <div class="border-start" style="width: 20%">
            <div class="text-muted mb-1">Data</div>
            <div class="">
              <span class="fw-semibold">{{ selected.data }}</span>
            </div>
          </div>

          <div class="border-start" style="width: 13%">
            <div class="text-muted mb-1">Score</div>
            <div class="text-truncate-custom fw-bolder" [ngClass]="'text-' + riskClass(selected.risk!)">{{selected.result!.toFixed(1)}}</div>
          </div>
        </div>
      </ng-template>
      <ng-template #body>
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <a aria-selected="true" class="nav-link active" data-bs-toggle="tab" href="#caseResults" role="tab">{{'pages.reporting.tabs.case' | translate}}</a>
          </li>
          <li class="nav-item" role="presentation">
            <a aria-selected="true" class="nav-link" data-bs-toggle="tab" href="#caseEntity" role="tab">{{'pages.reporting.tabs.entry' | translate}}</a>
          </li>
        </ul>

        <div class="tab-content bg-white" id="tabContent">
          <div class="tab-pane fade show active p-2 pb-0" id="caseResults" role="tabpanel">
            <div class="row mb-2">
              <div class="col-3">
                <div class="text-muted small mb-1">Batch</div>
                <div class="fw-semibold">{{selected.batch!}}</div>
              </div>

              <div class="col-3">
                <div class="text-muted small mb-1">External</div>
                <div class="fw-semibold" [hidden]="selected.external != 'OFF'">{{selected.external!}}</div>
                <div class="fw-semibold" [hidden]="selected.external == 'OFF'">
                  <a href="{{caseManagerUrl}}" target="_blank" rel="noopener noreferrer" type="button" class="btn text-action-2 fs-5 text-info p-0">
                    {{ selected.external }}
                  </a>
                </div>
              </div>

              <div class="col-3">
                <div class="text-muted small mb-1">Report</div>
                <div class="fw-semibold">{{selected.report!}}</div>
              </div>

              <div class="col-3">
                <div class="text-muted small mb-1">Entity</div>
                <div class="fw-semibold">{{selected.entity!}}</div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="text-muted small mb-1">Info</div>
                <div class="text-dark">{{selected.info}}</div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-6 text-start">
                <button class="btn btn-sm dropdown-toggle btn-outline-purple rounded-1 btn-sm me-3" type="button" data-bs-toggle="dropdown" aria-expanded="false"> Change status </button>
                <ul class="dropdown-menu dropdown-menu-start bg-bg-3">
                  <li><a class="dropdown-item">New</a></li>
                  <li><a class="dropdown-item">Open</a></li>
                  <li><a class="dropdown-item">Closed</a></li>
                  <li><a class="dropdown-item">Reported</a></li>
                </ul>
              </div>
              <div class="col-6 text-end">
                <button class="btn btn-sm btn-outline-no rounded-1 me-2 disabled"><i class="bi bi-check me-1"></i>No</button>
                <button class="btn btn-sm btn-outline-yes rounded-1 disabled"><i class="bi bi-x me-1"></i>Yes</button>
              </div>
            </div>
          </div>

          <div class="tab-pane fade show p-2 pb-0" id="caseEntity" role="tabpanel">
            <ng-container *ngFor="let field of selected.entry!.data">
              <div class="row align-items-center" [hidden]="field.config!.name == 'ID' || field.config!.hash == undefined">
                <span class="col-2 text-muted small">{{ field.config!.name }}</span>
                <div class="col-9 text-dark border field-data-content">
                  {{ field.value! | json}}
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </admin-panel-result>
  </admin-section-standard>

  <admin-section-standard [title]="'pages.reporting.title.reasons' | translate">
    <admin-panel-empty>
      <table class="table mb-0">
        <tbody class="table-group-divider">
        <tr *ngFor="let rr of selected.reasons">
          <td><span [ngClass]="'text-uppercase bg-' + riskClass(rr.risk!)" class="badge">{{('pages.lookup.result.risk.' + rr.risk | translate)}}</span></td>
          <td class="text-dark">{{ rr.reason }}</td>
        </tr>
        </tbody>
      </table>
    </admin-panel-empty>
  </admin-section-standard>

  <admin-section-standard [title]="'pages.reporting.title.factors' | translate">
    <admin-panel-empty>
      <admin-accordion-nice [items]="selected.factors">
        <ng-template #first let-item let-index="index" let-refid="refid">
          <admin-lookup-common-rules [factor]="item" class="row"/>
        </ng-template>
        <ng-template #second let-item>
          <admin-panel-inner>
            <admin-lookup-common-factor [factor]="item"/>
          </admin-panel-inner>
        </ng-template>
      </admin-accordion-nice>
    </admin-panel-empty>
  </admin-section-standard>

</admin-page-second>
</div>

<ng-template #loading>
  <p></p>
</ng-template>
